__turbopack_context__.v({
  "chatContainer": "chat-module-scss-module__OpjOLa__chatContainer",
});
